export const JA = {
  banner: {
    error: "見積もりは更新されません。しばらくお待ちください",
    copicate: "新しいポートフォリオモードをお試しください",
    antimonitor:
      "仮想通貨の購入や取引に最適なプラットフォームはこちらをクリック！",
  },
  footer: {
    donating: "CoinTrackrを気に入っていただけましたら、寄付をご検討ください！",
    right_reserve:
      "© Copyright " +
      new Date().getFullYear() +
      " by CoinTrackr.com.一部無断転載禁止。",
    version: "バージョン",
    changelog: "変更履歴",
    powered_by: "Powered by",
  },
  top: {
    about: {
      info: "情報",
      FAQ: "よくある質問",
      contact: "お問い合わせ",
      partners: "パートナー",
      terms: "利用規約",
      privacy: "プライバシーポリシー",
    },
  },
  content: {
    valuation: {
      current_valuation: "現在の評価額",
      approx: "概算",
    },
    profit_losses: "損益",
    updating_assets: "資産を更新しています",
    updated_now: "更新しました",
    last_update: `{time} 秒前に更新しました`,
    last_update_minutes: `{minutes}分{seconds}秒前に更新しました`,
  },
  assets: {
    your_assets: "保有中の資産",
    add_asset: "資産を追加する",
    sort: "並べ替え",
    sort_name: {
      name: "名称",
      exchId: "取引所",
      price: "価格",
      value: "評価額",
      holdings: "保有量",
      percChangeHour: "時",
      percChangeDay: "日",
      percChangeWeek: "週",
    },
  },
  charts: {
    color_help: "円グラフをクリックすると色が変更できます",
  },
  contact_page: {
    contact: "お問い合わせ",
    help_feedback: "ヘルプ＆フィードバック",
    telegram: "Telegram",
    twitter: "Twitter",
    medium: "Medium:",
    busines: "ビジネスに関するお問い合わせ",
    email: "Email",
  },
  partner_page: {
    partners: "当社のパートナー",
    bitsify:
      "Bitsifyは実施予定のICOとクラウドセールに関する詳細なレポートを提供します。",
    bitcoin:
      "Bitcoin for Beginnersは暗号通貨について学べる初心者向けのコミュニティです。",
    interest: "パートナーシップにご興味をお持ちですか？",
    contact_us: "当社にお問い合わせください！",
  },
  user_menu: {
    not_logged: "ログインしていません",
    icognito: "匿名",
    settings: "設定",
    sign_in: "サインイン",
    sign_out: "サインアウト",
    valuation: "タブに評価額を表示する",
    incognito: "シークレットモード",
    night_mode: "ナイトモード",
    share_link: "共有リンクを作成する",
  },
  FAQ: {
    expand: "すべてを表示する",
    collapse: "すべてを折りたたむ",
    0: {
      title: "CoinTrackrとは？",
      text:
        "CoinTrackrは暗号通貨投資の追跡に役立つように設計された無料でシンプルかつ便利なサービスです。",
    },
    1: {
      title: "CoinTrackrでどのように自分のポートフォリオを作成しますか？",
      text:
        "簡単に作成できます！サンプルポートフォリオの資産を削除し、ご自身の資産に置き換えるだけです。サンプルポートフォリオをクリックするだけで資産を削除または編集できます。",
    },
    2: {
      title: "CoinTrackrはどこで通貨価格を取得してますか？それは、正確ですか？",
      text:
        'すべての通貨価値に関するデータは<a href="https://coinmarketcap.com">coinmarketcap.com</a>から取得しており、CoinMarketCapに支援されている通貨取引所間の平均価格を表示しております。CoinTrackrは平均価格を使用しているため、取引所で提示されている厳密な価格とは若干の相違が見られる場合があります。',
    },
    3: {
      title:
        "APIキーを追加してCointrackrで取引するにはどのようにすればいいですか？",
      text:
        '専用ページ（<a href="/exchange/how-it-works">こちら<a>）に従って操作して下さい。',
    },
    4: {
      title: "今後、取引所を増やす予定はありますか？",
      text: "はい、APIキーを提供している取引所を追加していく予定です。",
    },
    5: {
      title: "評価額とは？それは、どのように決定されますか？",
      text:
        "バリュエーションとは、CoinTrackrに追加されたお客様の全アセットの総価値であり、現在保有中の暗号通貨ポートフォリオの総計となります。",
    },
    6: {
      title: "表示されない通貨があるのはなぜですか？",
      text:
        "通貨の名称を正しく記入しているにも関わらず、表示されない場合は、CoinMarketCapでサポートされていない通貨の可能性がございます。価格データに対して複数のデータ取得先を追加できるよう取り組んでおりますので、今後お持ちの通貨も対応される可能性がございます。",
    },
    7: {
      title: "ポートフォリオとログイン情報はどのように保存できますか？",
      text:
        "ログインがお済みでない場合は、すべての情報がお使いのブラウザキャッシュに保存されます。再度資産を追加する必要なく、ウィンドウを閉じ、後ほど再アクセスすることができます。" +
        "\n" +
        "CoinTrackrにご登録いただいている場合（ソーシャルログイン/メールおよびパスワード）、お客様のデータは当社のデータベースに保存されます。お客様がブラウザキャッシュを消去した場合でも、お客様の複数のデバイス（デスクトップやモバイル）間でリアルタイムな同期とデータ保存の為に保存されております。",
    },
    8: {
      title: "CoinTrackrでアカウントを作成するのは安全ですか？",
      text:
        'はい。お客様のデータはCoinTrackrの主要機能を有効にする用途のみに利用されます。お客様のデータはいかなる状況でも第三者に譲渡されません。詳細については <a href="/privacy">プライバシーポリシー<a/>を参照してください。',
    },
    9: {
      title:
        "CoinTrackrと暗号関連サービス/コミュニティとのパートナーシップ提携について",
      text:
        '是非、検討させていただきたく思います。パートナーシップ提携に関しては当社に<a href="/contact">お問い合わせ<a/> ください。',
    },
  },
  add_page: {
    search: "名称または記号で検索",
    add_asset: "資産を追加",
    any_asset: {
      1: "",
      2: "に記載の資産（通貨・トークン）がサポートされています",
    },
    next: "次へ",
    no_result: "見つかりませんでした",
  },
  register_page: {
    register: "登録",
    agree: "登録することで、以下に同意します",
    terms: "利用規約",
    and: "および",
    privacy: "プライバシーポリシー",
    p_reg:
      "登録は <b>無料かつ任意</b>です。 <b>他のデバイス</b>で利用するために<b>ポートフォリオを保存</b>するか、<b>ブラウザキャッシュを消去してしまった場合</b>にポートフォリオの紛失を防ぐことを希望する場合にのみ必要となります。",
    errors: {
      email_required: "メールアドレスは必須です。",
      email_valid: "有効なメールアドレスである必要があります。",
      password_required: "パスワードは必須です。",
      password_length: "パスワードは{length}文字以上である必要があります。",
      password_match: "パスワードが一致する必要があります。",
    },
    placeholder: {
      email: "メールアドレスを記入してください",
      password: "パスワードを記入してください",
      password_repeat: "パスワードをもう一度記入してください",
    },
    create_account: "アカウントを作成する",
  },
  login_page: {
    placeholder: {
      email: "メールアドレスを記入してください",
      password: "パスワードを記入してください",
    },
    errors: {
      email_not_found:
        "この識別子に対応するユーザー記録はありません。ユーザーが削除された可能性があります。",
      not_email: "メールアドレスの形式が正しくありません。",
    },
    forget_password_text:
      "パスワードを忘れた場合は、ここをクリックしてリセットしてください",
    forget_password_text_back: "サインインに戻る",
    reset_password: "パスワードを再設定する",
    reset_password_p:
      "以下にメールアドレスを入力してください。パスワードをリセットするためのメールが送信されます。",
    reset_password_success:
      "CoinTrackrのパスワードリセットメッセージが送信されました。 受信トレイを確認して、戻ってきてください。",
    // forget_password_text: 'If you forget your password, please send us an Email to: <a href="mailto:info@cointrackr.com">info@cointrackr.com</a> to reset it',
  },
  share_page: {
    heading: "共有リンクを作成する",
    just_second: "しばらくお待ちください...",
    porfolio_not_found: "ポートフォリオが見つかりません",

    p_1:
      "<strong>CoinTrackr</strong>は無料の<strong>仮想通貨ポートフォリオ管理サービス</strong>であり、利益・損失を追跡し、<strong>他者とポートフォリオの共有</strong>が可能です。",
    create_own: "無料でポートフォリオを作成する",

    p_2:
      "<strong>他のユーザーからポートフォリオが共有されました！</strong> <br> CoinTrackr は4,000種類の通貨・トークンをサポートする無料の仮想通貨ポートフォリオ管理サービスです。",
    porfolio: "ポートフォリオ",
    profit_losed: "損益",

    created: "作成完了",
    dialog: {
      p_1:
        "ポートフォリオを共有することにより、お客様の<strong>匿名ポートフォリオ</strong>を閲覧できる<strong>公開リンク</strong> が作成されます。 リンク先には<strong>保有資産の割合のみ</strong>が含まれ、バリュエーションや価格は含まれません。お客様の情報を追跡することはできず、安全に他者と共有できます。 ",
      add_message: "<strong>メッセージを追加する</strong> <em>(任意)</em>",
    },
    create_shareble: "共有リンクを作成する",
    create_own_free: "ポートフォリオを作成する",
    messages: {
      already: "ポートフォリオリンクの共有が可能です！🙌",
      copied: "リンクがコピーされました！🎉",
      not_copied:
        "リンクをコピーできませんでした。手動でコピーしてください。😢",
      failed: "リンクの作成に失敗しました。もう一度やり直してください。😢",
    },
  },
  global: {
    add_first: "最初の資産を追加する",

    not_now: "後で",
    not_right_now: "後で",
    close: "閉じる",
    go_back: "戻る",
    share: "保有率",

    price: "価格",

    day: "日",
    hour: "時",
    week: "週",
    valuation: "評価額",
    holdings: "保有量",
    name: "名称",
    actions: "アクション",
    edit: "編集",
    notes: "備考",

    last_7_days: "7日間以内",
    last_24_hour: "24時間以内",
    last_hour: "1時間以内",

    login: "ログイン",
  },
  sign_in_dialog: {
    button: {
      email: "メールアドレスでサインインする",
      facebook: "Facebookでサインインする",
      google: "Googleでサインインする",
      twitter: "Twitterでサインインする",
    },
    p:
      "サインインは <b>無料かつ任意</b>です。 <b>他のデバイス</b>で利用するために<b>ポートフォリオを保存</b>するか、<b>ブラウザキャッシュを消去してしまった場合</b>にポートフォリオの紛失を防ぐことを希望する場合にのみ必要となります。",
  },
  notifications: {
    sign_in: "サインインしました。",
    sign_out: "サインアウトしました。",
    HODL: "HODLしないのですか？😭",
    dont_worry:
      "ご心配なく。安心してください...そして、保有し続けましょう 🎶 🚀",
  },
  edit_asset_page: {
    add: "追加または編集",
    how_much: "{assetName} {assetSymbol}をどれほど保有していますか？",
    save: "保存",
    delete: "削除",
    notes_label: "備考 ({assetName} {assetSymbol}):",
    notes_placeholder:
      "購入価格、取引所、ウォレットアドレスなど、資産に関する備考が追加できます。",
  },
  exchange: {
    exchange: "取引所",
    trade: "取引",

    your_api_keys: "APIキー",
    how_it_works: "使い方は？",

    home_valuation_per_exchange: "取引所ごとの評価額",
    home_show_valuation_per_exchange: "取引所ごとの評価額を表示",
    home_tooltip_info: "取引所のAPIキーについてはこちらをご覧ください。",

    api_key: "APIキー",
    secret: "Secretキー",
    add: "追加",
    update: "更新",
    cancel: "キャンセル",
    add_your_exchange_api_key: "{exchange}のAPIキーを追加",
    add_exchange_api_key: "{exchange}のAPIキーを追加",
    update_exchange_api_key: "{exchange}のAPIキーを更新",
    api_keys_page_note:
      "重要：入金／出金や注文が成立した後、Binanceからの更新には状況によって15分程度の遅延が発生します。",

    pick_a_ticker_to_trade: "取引するティッカーを選択：",
    select_ticker: "ティッカーを選択",

    loading: "ローディング中...",
    Buy: "買い",
    Sell: "売り",
    LIMIT: "指値",
    MARKET: "成行",

    amount: "数量",
    you_have: "所有数",
    total: "合計",

    place_buy_order: "買い注文",
    place_sell_order: "売り注文",

    order_placed: "注文済み！",

    you_dont_have_assets: "取引する資産がありません",

    orders_history: "注文履歴",
    orders_open: "未決済注文",
    orders_history_empty: "{ticker} の注文履歴はありません",
    orders_open_empty: "現在、{ticker} の未決済注文はありません",
    symbol: "シンボル",
    side: "売買",
    type: "種別",
    price: "価格",
    status: "ステータス",
    stopPrice: "逆指値",
    executedQty: "注文数量",
    time: "日付",
    action: "アクション",
  },
  exchange_info_page: {
    blocks: [
      {
        heading: "CoinTrackr メジャーアップデート",
        p: [
          "CoinTrackrは、何年にもわたってユーザーの皆様に何十億ものレート情報を無料で提供してきましたが、この度、大規模アップデート情報を発表します。本日より、様々な取引所で保有している実際の暗号資産をCointrackr上でトラッキングできるようになりました！",
          "もう１つ……トラッキングだけではありません！暗号資産の取引機能の実装についてもご案内致します。Cointrackrの中で、暗号資産のトラッキングと、取引が可能になりました！",
        ],
      },
      {
        heading: "使い方は？",
        p: [
          "大規模な取引所では、ユーザーがAPIを使用して別のプラットフォームに接続できるようにしています。 たとえば、Binanceでは以下のようにオプションを提供しています。",
          "1) CoinTrackrに登録し、「APIキー」メニューを開きます",
          "2) BinanceアカウントからAPIキーとSecretキーをコピー＆ペーストします。<br /> 手順はこちらの画像をご参照下さい：",
          '<em>重要</em>："<strong>Enable reading</strong>"と"<strong>Enable Spot & Margin Trading</strong>"のみを有効にして下さい。<br /> また、IP制限でCoinTrackrのIPアドレス（<strong>{exchangeApiIP}</strong>）を設定してください。',
          "同期が完了したら、15分程待ってからホームページにアクセスすると、あなたのBinanceの資産がBinanceのロゴで表示されます。",
          "また、もう１つの重要な違いは、従来のCoinTrackr資産には、[編集]ボタンが表示されていましたが、アップデートによってCoinTrackrで取引所のポートフォリオの管理や取引も出来るようになった為、このボタンは[取引]に変更されました。",
          "それでは、CoinTrackのダッシュボードを見てみましょう：",
          "最初のページでは、Binanceと旧CoinTrackrで保有している資産を区別して表示しています。",
          "ご覧のように、取引所ごとに資産を区別する新しい列があります。<br /> > CoinTrackrロゴの行は、あなたがトラッキングしている旧資産に設定されています。<br /> > Binanceロゴの行は、Binanceのライブアカウントでトラッキングしている実際の資産です。",
        ],
      },
      {
        heading: "取引ページ",
        p: [
          "(利用規約への同意後)",
          "こちらで、CoinTrackrの取引ページを見てみましょう。各取引所資産の[取引]をクリックすれば、いつでもアクセスできます。",
          "こちらのように、[取引]をクリックすると、次のようなオプションがあります。<br /> 資産の「買い」と「売り」、「指値」と「成行」の2つのオプションがあります。",
          '注意：このオプションを有効にするには、Binance APIキーを作成する際に「Enable Spot & Margin Trading」から「Authorise trading」を選択する必要があります、<a href="#step-2-binance-setup">こちらをクリックしてBinanceのセットアップを再度確認してください。</a>',
          "こちらの機能を使用したくない場合は、以前と同様に資産のトラッキングのみご利用頂けます。",
          "現段階で、追加可能な取引所はBinanceのみですが、今後様々な取引所を追加していきます。",
          'ご質問やバグを発見された場合は、<a href="mailto:info@cointrackr.com">info@cointrackr.com</a> までご連絡下さい。ありがとうございました！',
        ],
      },
    ],
  },
  profitloss: {
    pl: "P／L",
    profitloss: "利益／損益",
    realized_profitloss: "実現利益／損益",
    total_balance: "合計残高",
    mode: "モード",
    portfolio: "ポートフォリオ",
    current: "現在",
    history: "履歴",
    investment: "投資額",
    average: "平均値",
    transaction: "取引",
    transactions: "取引",
    hide: "非表示",
    show: "表示",
    asset_notes_label: "資産に関するメモ",
    asset_notes_placeholder: "資産グループの取引関連のメモを追加",
    reset_portfolio: "ポートフォリオをリセット",
    reset_portfolio_text: "トランザクションを全て削除しますか？",
    list_empty: "リストは空です",

    quantity: "数量",
    value: "価格",
    date: "日付",
    buy_price: "購入価格",
    buy_value: "買値",
    buy_date: "購入日",
    showInValuation_help: "PNLを現在の評価額に含める",
    transaction_notes_placeholder: "取引に関するメモをここに追加",
    sell_close: "売却／完了",
    total_valuation: "合計評価額",
    delete_transaction_text: "この取引を削除しますか？",

    sell_price: "売却価格",
    sell_value: "売値",
    sell_date: "売却日",
    history_transaction_hint: "この取引は完了しました",

    original_buy_transaction: "{date} からの買い注文",
    left_unsold: "売り残",
    originally: "元",
    dependent_transactions: "この取引に関して、取引完了が {count} 件で合計 {amount} です",
  },
};
